import { inject, Inject, Injectable } from "@angular/core";
import { Environment } from "../environments/environment.interface";
import { ENVIRONMENT } from "../environments/environments.token";
import { CryptoService } from "./crypto.service";
import { StorageHandlerService } from "./storage-handler.service";

@Injectable({
  providedIn: "root",
})
export class SessionStorageService {
  private readonly cryptoService = inject(CryptoService);
  private readonly storageHandlerService = inject(StorageHandlerService);
  private env: Environment = inject(ENVIRONMENT);

  constructor() {}

  public setItem(key: string, value: string) {
    this.storageHandlerService.setItem(key, this.cryptoService.encrypt(value, this.env.SECRET_KEY || "demo"));
  }

  public getItem(key: string): string {
    const currentSession: string = this.storageHandlerService.getItem(key);
    if (!currentSession) return currentSession;
    return this.cryptoService.decrypt(currentSession, this.env.SECRET_KEY || "demo");
  }
}
